import { useMemo } from 'react';
import { Checkbox, ClearableInput, Select, SimpleTooltip } from '@rio-cloud/rio-uikit';
import { useIntl } from 'react-intl';

interface UptimeSidebarHeaderProps {
    viewMode: 'assets' | 'groups';
    vehicleTypeCounts: Record<string, number>;
    areAllFilteredAssetsSelected: boolean;
    areSomeFilteredAssetsSelected: boolean;
    onSearchTermChange: (searchTerm: string) => void;
    onViewModeChange: (viewMode: 'assets' | 'groups') => void;
    onToggleSelectAll: () => void;
}

const UptimeSidebarHeader = ({
    viewMode,
    vehicleTypeCounts,
    areAllFilteredAssetsSelected,
    areSomeFilteredAssetsSelected,
    onSearchTermChange,
    onViewModeChange,
    onToggleSelectAll,
}: UptimeSidebarHeaderProps) => {
    const intl = useIntl();

    const viewModeOptions = useMemo(
        () => [
            {
                id: '1',
                label: intl.formatMessage({ id: 'intl-msg:assetsTree.vehicles' }),
                short: 'assets',
                icon: <span className='rioglyph text-size-16 rioglyph-status-driving text-color-primary' />,
                selected: viewMode === 'assets',
            },
            {
                id: '2',
                label: intl.formatMessage({ id: 'intl-msg:assetsTree.groups' }),
                short: 'groups',
                icon: <span className='rioglyph text-size-16 rioglyph-tag text-color-primary' />,
                selected: viewMode === 'groups',
            },
        ],
        [viewMode]
    );

    return (
        <div className='TreeHeader'>
            <div className='TreeSearch width-100pct'>
                <div className='input-group width-100pct'>
                    <span className='input-group-addon'>
                        <span className='rioglyph rioglyph-search' aria-hidden='true' />
                    </span>
                    <ClearableInput
                        placeholder={viewMode === 'assets' ? intl.formatMessage({ id: 'intl-msg:assetsTree.searchVehicles' }) : intl.formatMessage({ id: 'intl-msg:assetsTree.searchGroups' })}
                        onChange={onSearchTermChange}
                    />
                    <SimpleTooltip content='Tipo de busca'>
                        <span className='input-group-btn'>
                            <Select
                                pullRight
                                showSelectedItemIcon
                                dropdownClassName='width-auto'
                                onChange={item => onViewModeChange(item?.short as 'assets' | 'groups')}
                                options={viewModeOptions}
                                placeholder={intl.formatMessage({ id: 'intl-msg:assetsTree.searchType' })}
                            />
                        </span>
                    </SimpleTooltip>
                </div>
            </div>

            <div className='TreeHead display-flex gap-5 padding-15'>
                <div className='border border-right-only hidden-empty padding-right-10 margin-right-2'>
                    <div className='TreeSelectAll display-flex align-items-center'>
                        <label className='checkbox margin-top--1' id='checkbox-all'>
                            <Checkbox
                                indeterminate={areSomeFilteredAssetsSelected}
                                checked={areAllFilteredAssetsSelected}
                                onChange={onToggleSelectAll}
                            />
                        </label>
                    </div>
                </div>
                <div className='display-flex justify-content-between align-items-start width-100pct'>
                    <div className='TreeSummary display-flex flex-wrap align-items-center gap-10 padding-left-3'>
                        {Object.entries(vehicleTypeCounts).map(([type, count]) => (
                            <div
                                key={type}
                                className='TypeCounter display-flex align-items-center user-select-none margin-right-2 cursor-pointer'
                            >
                                <span className={`rioglyph rioglyph-${type} text-size-16 margin-right-2`} />
                                <span className='TreeLabelCount label label-condensed label-muted label-filled'>
                                    {count}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UptimeSidebarHeader;
